import React from "react";
import "../../../styles/ComponentsStyles/Universal/Tables/UniversalTable.style.css";

const UniversalTable = ({ columns, data, footer, maxBodyHeight = "400px" }) => {
  return (
    <div className="universal-table-container">
      <table className="universal-table">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                style={{
                  textAlign: col.align || "left",
                  minWidth: col.minWidth,
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
      </table>

      {/* Scrollable table body */}
      <div
        className="universal-table-body-scroll scroll-y"
        style={{ maxHeight: maxBodyHeight }}
      >
        <table className="universal-table">
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="no-data">
                  No data available
                </td>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td
                      key={colIndex}
                      style={{ textAlign: col.align || "left" }}
                    >
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Optional footer */}
      {footer && <div className="table-footer-content pt-05">{footer}</div>}
    </div>
  );
};

export default UniversalTable;
